import React from 'react';
import { Card } from '@scalingworks/react-admin-ui';

interface FormSectionProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({ 
  icon, 
  title, 
  children 
}) => (
  <Card className="p-6 hover:shadow-lg transition-shadow duration-200">
    <div className="flex items-center gap-3 mb-6 pb-3 border-b border-gray-200">
      <div className="text-indigo-600 text-xl">{icon}</div>
      <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
    </div>
    <div className="space-y-5">{children}</div>
  </Card>
);